import { useGLTF } from '@react-three/drei'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import {
  modelParts, leftLogoParts,
  rightLogoParts,
  leftLogoCoords,
  rightLogoCoords,
  numberCoords,
} from '../../assets/models/349'
import {
  Ribs,
  MainSeat,
  RaceNumber,
  LogoMain,
  LogoRight,
  LogoLeft,
  TopPanelTexture,
} from './ModelSubComponents'


// This is one of the eBike models (AKA Surron)
// Link to test
// /?type=ebike1&subtype=ribbed&test=yes

const Model349 = (props) => {

  const snap = useSnapshot(state.current)
  const { nodes, materials } = useGLTF(modelParts.main)

  // Model Variables
  const masterScale = 1.3
  const neededRibs = 4
  const ribPosition = [0.002, 0.025, 0.285]
  const ribScale = 1.063
  const topPanelTextureRepeat = 2.5

  const enjoyLogoPosition = [0.001, 0.032, 0.24]
  const enjoyLogoScale = 1
  const hexaLogoPosition = [0.001, 0.03, 0.238]
  const hexaLogoScale = 0.768

  //________ No edits required below ________//

  // Controls which extra parts are visible
  const visibleRibs = snap.choices.ribs.selected.mode !== 'no'
  const visibleTopLogo = snap.initialChoices.logoSize !== 'none'
  const visibleNumber = snap.choices.raceNumber.selected.mode === 'number'
  const visiblePattern = snap.choices.topPanel.selected.src !== null

  return (
    <group {...props} dispose={null} scale={masterScale}>
      <MainSeat nodes={nodes} materials={materials}>
        {visiblePattern && (
          <TopPanelTexture
            repeat={topPanelTextureRepeat}
            normal={materials.TopPanel.normalMap}
          />
        )}
      </MainSeat>

      {visibleRibs && (
        <Ribs
          model={modelParts.ribs}
          neededRibs={neededRibs}
          position={ribPosition}
          scale={ribScale}
          tiles={0.8}
        />
      )}
      {visibleTopLogo && (
        <LogoMain
          model={modelParts.logoMain}
          model2={modelParts.logoHexa}
          position={enjoyLogoPosition}
          scale={enjoyLogoScale}
          position2={hexaLogoPosition}
          scale2={hexaLogoScale}
        />
      )}

      <RaceNumber model={modelParts.number} coords={numberCoords} />


      <LogoLeft
        model={leftLogoParts}
        logo={snap.choices.sideLogos.selected.mode}
        coords={leftLogoCoords}
      />
      <LogoRight
        model={rightLogoParts}
        logo={snap.choices.sideLogos.selected.mode}
        coords={rightLogoCoords}
      />

    </group>
  )
}

export default Model349

useGLTF.preload(modelParts.main)
useGLTF.preload(modelParts.logoMain)
useGLTF.preload(leftLogoParts.enjoy)
useGLTF.preload(modelParts.logoMain)
